import * as React from "react";

import Spinner from './Spinner'

const ModalSpinner = () => {
  return (
    <div className="modal modal-spinner">
      <Spinner />
    </div>
  );
};

export default ModalSpinner;



// WEBPACK FOOTER //
// ./src/theme/ModalSpinner.js